// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Building = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Building = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Building = _exports.Building = function Building(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 1.875C4.65625 1.875 4.375 2.15625 4.375 2.5V17.5C4.375 17.8438 4.65625 18.125 5 18.125H8.125V15.625C8.125 14.5898 8.96484 13.75 10 13.75C11.0352 13.75 11.875 14.5898 11.875 15.625V18.125H15C15.3438 18.125 15.625 17.8438 15.625 17.5V2.5C15.625 2.15625 15.3438 1.875 15 1.875H5ZM2.5 2.5C2.5 1.12109 3.62109 0 5 0H15C16.3789 0 17.5 1.12109 17.5 2.5V17.5C17.5 18.8789 16.3789 20 15 20H5C3.62109 20 2.5 18.8789 2.5 17.5V2.5ZM5.9375 4.0625C5.9375 3.71875 6.21875 3.4375 6.5625 3.4375H8.4375C8.78125 3.4375 9.0625 3.71875 9.0625 4.0625V5.9375C9.0625 6.28125 8.78125 6.5625 8.4375 6.5625H6.5625C6.21875 6.5625 5.9375 6.28125 5.9375 5.9375V4.0625ZM11.5625 3.4375H13.4375C13.7812 3.4375 14.0625 3.71875 14.0625 4.0625V5.9375C14.0625 6.28125 13.7812 6.5625 13.4375 6.5625H11.5625C11.2188 6.5625 10.9375 6.28125 10.9375 5.9375V4.0625C10.9375 3.71875 11.2188 3.4375 11.5625 3.4375ZM5.9375 9.0625C5.9375 8.71875 6.21875 8.4375 6.5625 8.4375H8.4375C8.78125 8.4375 9.0625 8.71875 9.0625 9.0625V10.9375C9.0625 11.2812 8.78125 11.5625 8.4375 11.5625H6.5625C6.21875 11.5625 5.9375 11.2812 5.9375 10.9375V9.0625ZM11.5625 8.4375H13.4375C13.7812 8.4375 14.0625 8.71875 14.0625 9.0625V10.9375C14.0625 11.2812 13.7812 11.5625 13.4375 11.5625H11.5625C11.2188 11.5625 10.9375 11.2812 10.9375 10.9375V9.0625C10.9375 8.71875 11.2188 8.4375 11.5625 8.4375Z",
      fill: "currentColor"
    }));
  };
});
